var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-main-page pending-retailer"},[_c('BrandBanners'),_c('BrandMiddleBox',{attrs:{"textInfo":_vm.exploreList,"typeNumber":1}}),_c('BrandMiddleBox',{attrs:{"textInfo":_vm.learningList,"typeNumber":2}}),_c('BrandBottomBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }